import React from 'react'
import SlideToggle from 'react-slide-toggle'

const RenderFaq = ({ question, answer }) => (
    <div className="col-xs-12 col-sm-6">
        <SlideToggle
            collapsed
            render={({ toggle, setCollapsibleElement, toggleState }) => (
                <>
                    <dt
                        onClick={toggle}
                        className={
                            ['EXPANDED', 'EXPANDING', 'COLLAPSING'].includes(toggleState)
                                ? 'active'
                                : null
                        }
                    >
                        {question}
                    </dt>
                    <dd ref={setCollapsibleElement}>
                        <p>{answer}</p>
                    </dd>
                </>
            )}
        />
    </div>
)

const Faqs = ({ faqItems }) => (
    <>
        <h2>FAQs</h2>

        <dl id="faq-list" className="col-section col-no-margin">
            {faqItems.map(faqItem => {
                const {
                    sys: { id },
                    fields: { question, answer }
                } = faqItem

                return <RenderFaq key={id} question={question} answer={answer} />
            })}
        </dl>
    </>
)

export default Faqs
